const lang = {
  breadcrumb: {
    management: 'シミュレーション設定',
  },
  list: {
    page_title: 'シミュレーション設定',
    paginate_text: '全 {total} 件中 {from} 件 〜 {to} 件を表示',
    search: {
      prefecture: '都道府県',
      city: '市区町村',
      ownership: '所有形態',
      owner_id: '所有者',
    },
    button: {
      export_csv: 'CSVエクスポート',
      import_csv_forest_management_plan: 'CSVインポート(森林経営計画)',
      import_csv_forest_inventory: 'CSVインポート(林地台帳)',
      cancel: 'キャンセル',
      delete: '削除する',
      update: '更新',
    },
    label: {
      forest_group: '林班',
      small_forest_group: '小班',
      branch_group: '小班枝番',
      compensate_group: '小班補番',
      fcs_tree_species: '樹種',
      forest_age: '林齢',
      tree_height: '樹高',
      position: '地位',
      accumulation: '材積量',
      tree_volume_increment: '材積成長量',
      fcs_operation_id: '施業履歴',
      credit: 'クレジット化',
      function: '機能',
      plan_number: '計画番号',
    },
    credit_type: {
      not_yet: '未',
      done: '済',
    },
    message: {
      confirm_delete: '森林情報を削除しますがよろしいですか？',
      confirm_delete_all: '森林情報を全て削除しますがよろしいですか？',
    },
  },
  edit: {
    page_title: '森林情報を編集する',
  },
}

export default lang
